import { useLocation } from 'react-router-dom';
import StaticCrumb from '../StaticCrumb';

const PLATFORM_COSTS_PATH = '/admin/platform-costs';

const PlatformCostsCrumb = () => {
    const location = useLocation();
    const isOverview = location.pathname === PLATFORM_COSTS_PATH;

    return (
        <StaticCrumb label="Platform Costs" href={PLATFORM_COSTS_PATH} isCurrentPage={isOverview} />
    );
};

export default PlatformCostsCrumb;
